import { useContext } from 'react'
import { OptimizelyContext, useExperiment } from '@optimizely/react-sdk'
import useHasMounted from '@chegg-wt/core/hooks/useHasMounted'

interface UseOptimizelyExperiment {
  variation: string | null
  clientReady: boolean
  didTimeout: boolean
}

export const useOptimizelyExperiment = (
  experimentKey: string
): UseOptimizelyExperiment => {
  const hasMounted = useHasMounted()
  const { optimizely } = useContext(OptimizelyContext)

  // return early is ok here due to optimizely either existing or not, as it will not change
  if (!optimizely) {
    return {
      variation: null,
      // Never show ready for SSR
      clientReady: hasMounted,
      didTimeout: false,
    }
  }
  // eslint-disable-next-line
  const [variation, clientReady, didTimeout] = useExperiment(experimentKey)
  return {
    variation,
    clientReady,
    didTimeout,
  }
}
